import { render, staticRenderFns } from "./chooseCommunity.vue?vue&type=template&id=50286460&scoped=true&"
import script from "./chooseCommunity.vue?vue&type=script&lang=js&"
export * from "./chooseCommunity.vue?vue&type=script&lang=js&"
import style0 from "./chooseCommunity.vue?vue&type=style&index=0&id=50286460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50286460",
  null
  
)

export default component.exports